export const blockIconsCommunicationModeCommentNew = (
	<span className='material-symbols-outlined'>mode_comment</span>
);
